import { useLocale } from "@/i18n";
import { Notice } from "@/components/Notice";

export interface PeriodSelectedHintProps {
  message: string;
}

export function PeriodSelectedHint({ message }: PeriodSelectedHintProps) {
  const { messages: m } = useLocale();

  return (
    <Notice variant="success" title={m.periodSelected.title}>
      <p>{message}</p>
    </Notice>
  );
}
